import { Theme, useMediaQuery } from "@material-ui/core"

export const useIsSmallScreen = (breakpoint: "sm" | "xs" = "sm") => {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down(breakpoint))
}
